/**
 * Error thrown by frontend clients when an HTTP response is not OK.
 *
 * Carries the response `status` code so callers can branch on auth failures (401), forbidden actions (403), not-found (404), etc., rather than parsing free-form `message` strings.
 */
export class HttpError extends Error {
  /** HTTP status code from the failed response. */
  readonly status: number;

  /**
   * Constructs an HttpError.
   *
   * @param status - HTTP status code from the failed response.
   * @param message - Human-readable description of the failure.
   */
  constructor(status: number, message: string) {
    super(message);
    this.name = 'HttpError';
    this.status = status;
  }
}
